module.exports = __webpack_public_path__ + "static/img/irontong.ed844f84.gif";